import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { message } from 'antd';

import ChatWrapper from 'src/components/organisms/chat_wrapper';
import { AppType, fetchTatvaAiToken, removeAuthTokenFromURL, setAppType } from 'src/helpers/rest';
import { BASE } from 'src/common/constants';
import API from 'src/apis';
import helpers from 'src/helpers';
import { setOpenAIResponse } from 'src/redux/slices/open_ai';
import BrandLoading from 'src/components/atoms/brand_loading';

import styles from './index.module.scss';

const Homepage: React.FunctionComponent = () => {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [width, setWidth] = useState<number>(window.innerWidth);
    const [tokenLoading, setTokenLoading] = useState<boolean>(true);
    const [appType, _setAppType] = useState<AppType>('tatva_ai');

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const authToken = searchParams.get('authToken');
        const id = searchParams.get('id');

        if (!authToken || !id) {
            setTokenLoading(false);
        } else {
            setStateData(authToken, id);
        }
    }, [searchParams]);

    const setStateData = async (authToken: string, id: string) => {
        try {
            localStorage.clear();
            setAppType(searchParams, _setAppType);
            removeAuthTokenFromURL();

            await fetchTatvaAiToken(authToken, setTokenLoading, false);
            const histories = await fetchHistory();

            // Redirect to history page if no histories found
            if (!histories?.length) {
                navigateToPage('/history');
                return;
            }

            const history = histories.find((h: any) => h.id === id);

            // Redirect to history page if specified history is not found
            if (!history) {
                navigateToPage('/history');
                return;
            }

            dispatch(setOpenAIResponse([...history.openAiResponses]));
            navigateToPage('/');
        } catch (error) {
            console.error(error);
            message.error('Something went wrong!');
            setTokenLoading(false);
        }
    };

    const navigateToPage = (page: string) => {
        navigate(page);
        setTokenLoading(false);
    };

    const fetchHistory = async () => {
        try {
            const url = new URL(BASE.API_HOST);
            url.searchParams.append('page', '1');
            url.searchParams.append('limit', '20');

            const jsonData = await API.GetHistory(url.search);
            const structuredData = helpers.modifyHistoryResponseData(jsonData);
            if (jsonData.data && jsonData.data.length && structuredData.data.length) {
                return structuredData.data;
            }
            return [];
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>{
            tokenLoading
                ? <BrandLoading app={appType}/>
                : <div className={`${width < 900 ? styles.homepage_mobile : styles.homepage_wrapper}}`}>
                    <ChatWrapper />
                </div>
        }</>
    );
}

export default Homepage;